
namespace appn.pubSub {

    export const APPN_READY = 'appn.system.ready';
    export const DOM_READY = 'appn.system.domReady';
    export const VIEW_INIT_COMPLETE = 'appn.system.view.init.complete';
    export const WINDOW_RESIZED = 'appn.window.resized';
    export const DESIGNER_PROPS_UPDATED = 'appn.designer.propsUpdated'; 
    export const START_INTRO = 'appn.startIntro';

    export function publishAppnReady() {
        const loadTimeSeconds = new Date(new Date().getTime() - (window as any).appnLoadStart);
        const loadStats: any = { secs: loadTimeSeconds.getSeconds(), milli: loadTimeSeconds.getMilliseconds() };
        publish(APPN_READY, loadStats);
        log.info(loadStats);
    }

    export function publishDomReady() {
        const domReadySeconds = new Date(new Date().getTime() - (window as any).appnLoadStart);
        const domReadyStats: any = { secs: domReadySeconds.getSeconds(), milli: domReadySeconds.getMilliseconds() };
        publish(DOM_READY, domReadyStats);
        log.info(domReadyStats);
    }

    export function publish(channel: string, data?: any) {
        PubSub.publish(channel, data ? data : appn.emptyString);
    }
     
    export function publishSync(channel: string, data?: any) {
        PubSub.publishSync(channel, data ? data : appn.emptyString);
    }

    export function subscribe(channel: string, data: PubSubJS.SubscriptionListener<any>) {
        PubSub.subscribe(channel, data);
    }

    export function unSubscribe(channel: string) {
        PubSub.unsubscribe(channel);
    }

    export function clearAllSubscriptions() {
        PubSub.clearAllSubscriptions();
    }

}
